import { render, staticRenderFns } from "./issuable_by_email.vue?vue&type=template&id=063f56ce"
import script from "./issuable_by_email.vue?vue&type=script&lang=js"
export * from "./issuable_by_email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports